CollectionWithHelpers = require 'models/collections/internal/collection-with-helpers'
PendingOrganization = require 'models/pending-organization'

module.exports = class PendingOrganizationList extends CollectionWithHelpers
  model: PendingOrganization



// WEBPACK FOOTER //
// ./app/scripts/models/collections/pending-organization-list.coffee